import CrudCustom from '../../../libs/custom/CrudCustom';

let TarifProgresifPesangonService = new CrudCustom('/tarif-pesangons');
export default TarifProgresifPesangonService;
